

export const BOTTOM_PADDING = 26
export const CONTENT_HEIGHT = 80
export const SCENE_HEIGHT = CONTENT_HEIGHT + BOTTOM_PADDING

export const PRINT_INK_PX = 16
export const PRINT_HOUR_DIGIT_PX = 10

if (PRINT_INK_PX + PRINT_HOUR_DIGIT_PX !== BOTTOM_PADDING) {
  throw new Error(
    `print gutter ${PRINT_INK_PX}+${PRINT_HOUR_DIGIT_PX} must equal BOTTOM_PADDING ${BOTTOM_PADDING}`,
  )
}


export const REST_BLOCK_HEIGHT = 62
